import stylesheets from "./locale-fonts.json";

/** Canonical product codes only; callers resolve language preference or page URL. */
export function localeFontStylesheet(locale: string): string | null {
  return Object.prototype.hasOwnProperty.call(stylesheets, locale) ? stylesheets[locale] : null;
}
